import Axios from "axios";

import { 
  SET_BANK_RECONCILATION_RECORD_LIST, 
  UNSET_BANK_RECONCILATION_RECORD_LIST,
  SET_BANK_RECONCILATION_STATEMENT,
  UNSET_BANK_RECONCILATION_STATEMENT,
} from "@/store/mutation-types";


import {
  bankReconciliationRecord as bankReconciliationRecordApi,
  bankReconciliationCheckout as bankReconciliationCheckoutApi,
  bankReconciliationUndoCheckout as bankReconciliationUndoCheckoutApi,
  bankReconciliationStatement as bankReconciliationStatementApi
} from "@/store/api";

const state = {
  bankReconciliationRecordList: [],
  bankReconciliationStatement: [],
};


const getters = {
  bankReconciliationRecordList(state) {
    return state.bankReconciliationRecordList;
  },
   bankReconciliationStatement(state) {
    return state.bankReconciliationStatement;
  },
};


// Mutations
const mutations = {
  [SET_BANK_RECONCILATION_RECORD_LIST](state, data) {
    state.bankReconciliationRecordList = data;
  },
  [UNSET_BANK_RECONCILATION_RECORD_LIST](state) {
    state.bankReconciliationRecordList = [];
  },
  [SET_BANK_RECONCILATION_STATEMENT](state, data) {
    state.bankReconciliationStatement = data;
  },
  [UNSET_BANK_RECONCILATION_STATEMENT](state) {
    state.bankReconciliationStatement = [];
  },
};

// Actions
const actions = {
  /**
   * Get voucher list by type
   */
  bankReconciliationRecordList({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });

    return new Promise((resolve, reject) => {
      Axios.get(`${bankReconciliationRecordApi}`, { params: data })
        .then((response) => {
            if (response && response.data && Array.isArray(response.data.data) && response.data.data.length > 0) {
                commit(SET_BANK_RECONCILATION_RECORD_LIST, response.data.data[0]);
            } else {
                commit(SET_BANK_RECONCILATION_RECORD_LIST, []);
                console.warn('Bank reconciliation data not found or empty');
            }
        })
        .catch((error) => {
          commit(UNSET_BANK_RECONCILATION_RECORD_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

bankReconciliationStatement({ commit }, data) {
  commit("SET_LOADING", { color: "primary" });

  return new Promise((resolve, reject) => {
    Axios.get(`${bankReconciliationStatementApi}`, { params: data })
      .then((response) => {
        if (response && response.data && response.data.success && response.data.data) {
          // শুধু object আছে তাই directly commit কর
          commit(SET_BANK_RECONCILATION_STATEMENT, response.data.data);
        } else {
          commit(SET_BANK_RECONCILATION_STATEMENT, null);
          console.warn('Bank reconciliation data not found or empty');
        }
        resolve(response.data);
      })
      .catch((error) => {
        commit(UNSET_BANK_RECONCILATION_STATEMENT);
        reject(error);
      })
      .finally(() => {
        commit("UNSET_LOADING");
      });
  });
},


  bankReconciliationCheckout({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(bankReconciliationCheckoutApi, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

   bankReconciliationUndoCheckout({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(bankReconciliationUndoCheckoutApi, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

};


export default {
  state,
  getters,
  actions,
  mutations,
};